import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  LargeButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_LARGE_BUTTONS, EDGE_LARGE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={LargeButton} span={EDGE_LARGE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" color="primary" className="btn-pill" id="Tooltip-8">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-8" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-lg</ToolTip>
          {EDGE_LARGE_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} size="lg" />
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeLargeButtons;
